export const THOUSAND_SEPARATOR = Intl.NumberFormat('en-US')
  .format(11111)
  .replace(/\p{Number}/gu, '')

export const DECIMAL_SEPARATOR = Intl.NumberFormat('en-US')
  .format(1.1)
  .replace(/\p{Number}/gu, '')

export const ROOT_PATH = '/forex/:accountId'
